import script from "./TheScheduleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TheScheduleEdit.vue?vue&type=script&setup=true&lang=js"

import "./TheScheduleEdit.vue?vue&type=style&index=0&id=6b204028&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b204028"]])

export default __exports__